import { Injectable } from '@angular/core';
import { IValidationResponse } from '../../models/validation-response';
import { AppConstants, LabelConstants } from 'src/app/utilities/app-constants';
import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';
import { BatonFeature } from 'src/app/models/baton-features';
import { environment } from 'src/environments/environment';
import { FolioHelperService } from 'src/app/utilities/folio-helper.service';
import * as AWS from 'aws-sdk';

@Injectable({
  providedIn: 'root'
})
export class CoreServicesService {
  readonly MY_CONSTANT = LabelConstants;

  localUser: IValidationResponse;

  constructor(
    private http: HttpClient,
  ) {

    AWS.config.region = environment.awsRegion; // Region
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: environment.awsPoolId,
    });

  }

  getFeatures(user: IValidationResponse) {

    const url = environment.urlBatonGetFeatures;
    const options = {
      params: new HttpParams()
        .set(AppConstants.PARAM_APP_ID, '9')
        .set(AppConstants.PARAM_ENVIRONMENT, user.backendType ? user.backendType : '')
        .set(AppConstants.PARAM_CUSTOMER_ID, user.customerId.toString()),

      headers: new HttpHeaders().set(
        'cognitoToken',
        user.accessToken
      ).set('Content-Type', 'application/json')

    };

    return this.http.get<BatonFeature[]>(url, options);
  }

  lambdaInvoke(functionName: string, payload: {}) {
    // Needs to include a try-catch inside of the promise to catch any unhandled errors
    return new Promise((resolve, reject) => {
      const lambda = new AWS.Lambda({ region: environment.awsRegion, apiVersion: '2015-03-31' });
      const params = {
        FunctionName: functionName,
        InvocationType: 'RequestResponse',
        LogType: 'None',
        Payload: payload
      };
      lambda.invoke(params, (err, data) => {
        if (err) {
          console.log(err);
          reject(err);
        } else {
          resolve(data);
        }
      });
    });
  }

}
